module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/76.ebeb332d.png";